import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { Card, CardContent, CardHeader, CardTitle } from 'src/@/components/ui/card';
import { Badge } from 'src/@/components/ui/badge';

ChatAIAnalysis.propTypes = {
    data: PropTypes.object.isRequired,
};

export default function ChatAIAnalysis({ data }) {
    const { t } = useTranslation('chat');
    const mappSentiment = {
        "1": { label: t('aiAnalysis.sentiments.angry'), bg: "bg-red-100 border-red-200 text-red-700", icon: "emotion-angry" },
        "2": { label: t('aiAnalysis.sentiments.frustrated'), bg: "bg-orange-100 border-orange-200 text-orange-500", icon: "emotion-sad" },
        "3": { label: t('aiAnalysis.sentiments.neutral'), bg: "bg-gray-100 border-gray-200 text-gray-700", icon: "emotion-normal" },
        "4": { label: t('aiAnalysis.sentiments.satisfied'), bg: "bg-green-100 border-green-200 text-green-700", icon: "emotion-happy" },
        "5": { label: t('aiAnalysis.sentiments.verySatisfied'), bg: "bg-blue-100 border-blue-200 text-blue-700", icon: "emotion-satisfied" },
        "negative": { label: t('aiAnalysis.sentiments.negative'), bg: "bg-red-100 border-red-200 text-red-700", icon: "emotion-unhappy" },
        "neutral": { label: t('aiAnalysis.sentiments.neutral'), bg: "bg-gray-100 border-gray-200 text-gray-700", icon: "emotion-normal" },
        "positive": { label: t('aiAnalysis.sentiments.positive'), bg: "bg-green-100 border-green-200 text-green-700", icon: "emotion-happy" }
    };
    const aiAnalysis = data?.result;
    console.log(aiAnalysis);
    return (
        <Card className="mt-1 bg-gradient-to-br from-violet-50 to-white mb-2">
            {/* <CardHeader className="pb-2">
                <CardTitle className="text-base font-semibold flex items-center gap-2">
                    <Iconify icon="carbon:calendar" className="w-5 h-5 text-violet-600" />
                    <div className="flex items-center gap-2 felx-col">
                    <span className="text-violet-600">Última análise:</span>
                    <span className="text-sm text-gray-600">
                    {data?.date ? (
                        new Date(data.date).toLocaleDateString('pt-BR', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })
                    ) : 'Data não disponível'}
                    </span>
                    </div>
             
                </CardTitle>
            </CardHeader> */}
            <CardContent className="p-0">
                <div className="px-3 py-2 pb-6">
                    <div className="space-y-3">
                    <div className="bg-white p-3 rounded-lg shadow-sm space-y-2">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-1.5">
                                    <Iconify icon="carbon:face-satisfied" className="w-4 h-4 text-violet-600" />
                                    <span className="text-xs font-medium">{t('aiAnalysis.sentiment')}</span>
                                </div>
                                <Badge 
                                    className={`px-2 text-xs flex items-center gap-1 border ${mappSentiment[aiAnalysis?.sentiment]?.bg || "bg-gray-100 border-gray-200 text-gray-700"}`}
                                >
                                    <Iconify 
                                        icon={`carbon:${(mappSentiment[aiAnalysis?.sentiment]?.icon || "emotion-normal").replace(/\n/g, '')}`} 
                                        className="w-3.5 h-3.5" 
                                    />
                                    {(mappSentiment[aiAnalysis?.sentiment]?.label || t('aiAnalysis.sentiments.neutral')).replace(/\n/g, '')}
                                </Badge>
                            </div>
                        </div>
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="flex items-center gap-1.5 mb-2">
                                <Iconify icon="carbon:warning" className="w-4 h-4 text-violet-600" />
                                <span className="text-xs font-medium">{t('aiAnalysis.alerts')}</span>
                            </div>
                            <div className="space-y-1.5">
                                {aiAnalysis?.alerts?.length > 0 ? (
                                    aiAnalysis.alerts.map((alerta, index) => (
                                        <div key={index} className="flex items-center gap-1.5 p-1.5 bg-red-50 text-red-700 rounded-md text-xs">
                                            <Iconify icon="carbon:warning-alt" className="w-3.5 h-3.5 flex-shrink-0" />
                                            {alerta}
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-xs text-gray-500">{t('aiAnalysis.noAlerts')}</div>
                                )}
                            </div>
                        </div>

                        {/* Novo componente de Resumo */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="flex items-center gap-1.5 mb-2">
                                <Iconify icon="carbon:document-summary" className="w-4 h-4 text-violet-600" />
                                <span className="text-xs font-medium">{t('aiAnalysis.summary')}</span>
                            </div>
                            <div className="text-xs text-gray-600">
                                {aiAnalysis?.resume || t('aiAnalysis.noSummary')}
                            </div>
                        </div>

                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="flex items-center gap-1.5 mb-2">
                                <Iconify icon="carbon:list-checked" className="w-4 h-4 text-violet-600" />
                                <span className="text-xs font-medium">{t('aiAnalysis.subjects')}</span>
                            </div>
                            <div className="flex flex-wrap gap-1">
                                {aiAnalysis?.subject?.length > 0 ? (
                                    aiAnalysis.subject.map((assunto, index) => (
                                        <Badge key={index} variant="outline" className="bg-violet-50 text-xs px-2">
                                            {assunto}
                                        </Badge>
                                    ))
                                ) : (
                                    <div className="text-xs text-gray-500">{t('aiAnalysis.noSubjects')}</div>
                                )}
                            </div>
                        </div>

                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="flex items-center gap-1.5 mb-2">
                                <Iconify icon="carbon:idea" className="w-4 h-4 text-violet-600" />
                                <span className="text-xs font-medium">{t('aiAnalysis.suggestions')}</span>
                            </div>
                            <ul className="space-y-1.5">
                                {aiAnalysis?.suggestions?.length > 0 ? (
                                    aiAnalysis.suggestions.map((sugestao, index) => (
                                        <li key={index} className="flex items-start gap-1.5 text-xs text-gray-600">
                                            <Iconify icon="carbon:arrow-right" className="w-3.5 h-3.5 mt-0.5 flex-shrink-0" />
                                            <span>{sugestao}</span>
                                        </li>
                                    ))
                                ) : (
                                    <li className="text-xs text-gray-500">{t('aiAnalysis.noSuggestions')}</li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
} 